module.exports = __webpack_public_path__ + "static/img/jie.3211320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jie.jpg
// module id = OEA+
// module chunks = 1